<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{componentConditionManageInfo.componentName}} {{$t('componentConditionManage.condition')}}</span>
            <div>
              <el-button size="small" @click="_goBack()">{{$t('common.back')}}</el-button>
              <el-button type="primary" size="small" @click="_openAddComponentConditionModal()">
                <i class="el-icon-plus"></i>{{$t('common.add')}}
              </el-button>
            </div>
          </div>
          <el-table
            :data="componentConditionManageInfo.componentConditions"
            style="width: 100%"
            border
            stripe>
            <el-table-column
              prop="conditionId"
              :label="$t('componentConditionManage.conditionId')"
              align="center"
              width="120">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('componentConditionManage.name')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="holdpace"
              :label="$t('componentConditionManage.holdpace')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="param"
              :label="$t('componentConditionManage.param')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="type"
              :label="$t('componentConditionManage.type')"
              align="center">
              <template slot-scope="scope">
                {{scope.row.type == 'text' ? $t('componentConditionManage.text') : $t('componentConditionManage.date')}}
              </template>
            </el-table-column>
            <el-table-column
              prop="seq"
              :label="$t('componentConditionManage.seq')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="remark"
              :label="$t('componentConditionManage.remark')"
              align="center">
            </el-table-column>
            <el-table-column
              :label="$t('common.operation')"
              align="center"
              width="180">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    @click="_openEditComponentConditionModel(scope.row)">
                    {{$t('common.edit')}}
                  </el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="_openDeleteComponentConditionModel(scope.row)">
                    {{$t('common.delete')}}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="componentConditionManageInfo.conditions.page"
            :page-size="DEFAULT_ROWS"
            layout="total, prev, pager, next, jumper"
            :total="componentConditionManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-component-condition ref="addComponentCondition"></add-component-condition>
    <edit-component-condition ref="editComponentCondition"></edit-component-condition>
    <delete-component-condition ref="deleteComponentCondition"></delete-component-condition>
  </div>
</template>

<script>
import { listReportCustomComponentCondition } from '@/api/dev/componentConditionApi'
import AddComponentCondition from '@/components/dev/addComponentCondition/addComponentCondition.vue'
import EditComponentCondition from '@/components/dev/editComponentCondition/editComponentCondition.vue'
import DeleteComponentCondition from '@/components/dev/deleteComponentCondition/deleteComponentCondition.vue'

export default {
  name: 'ComponentConditionManage',
  components: {
    AddComponentCondition,
    EditComponentCondition,
    DeleteComponentCondition
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      componentConditionManageInfo: {
        componentConditions: [],
        total: 0,
        conditions: {
          componentId: '',
          name: '',
          param: '',
          page: 1,
          row: 10
        },
        componentName: ''
      }
    }
  },
  created() {
    this.componentConditionManageInfo.conditions.componentId = this.$route.query.componentId
    this.componentConditionManageInfo.componentName = this.$route.query.componentName
    this._listComponentConditions(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listComponentConditions(val, this.DEFAULT_ROWS)
    },
    async _listComponentConditions(page, rows) {
      this.componentConditionManageInfo.conditions.page = page
      this.componentConditionManageInfo.conditions.row = rows
      try {
        const res = await listReportCustomComponentCondition(this.componentConditionManageInfo.conditions)
        this.componentConditionManageInfo.total = res.total
        this.componentConditionManageInfo.componentConditions = res.data
      } catch (error) {
        console.error('获取条件列表失败:', error)
      }
    },
    _openAddComponentConditionModal() {
      this.$refs.addComponentCondition.open({
        componentId: this.componentConditionManageInfo.conditions.componentId
      })
    },
    _openEditComponentConditionModel(componentCondition) {
      this.$refs.editComponentCondition.open(componentCondition)
    },
    _openDeleteComponentConditionModel(componentCondition) {
      this.$refs.deleteComponentCondition.open(componentCondition)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>